'use strict';

var proto = require('./Array.prototype');

module.exports = {
	prototype: proto,
	shim: function shimArray() {
		proto.shim();
	}
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/es7-shim/Array.js
// module id = 778
// module chunks = 0